import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  getAEnquiry,
  resetState,
  updateAEnquiry,
} from "../features/enquiry/enquirySlice";
import { getaUser } from "../features/cutomers/customerSlice";

import { BiArrowBack } from "react-icons/bi";

const ViewCustomer = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const getEnqId = location.pathname.split("/")[3];
  const enqState = useSelector((state) => state.customer.customerinfo);

  const {
    _id,
    name,
    unique_id,
    email,
    phone_no,
    qualification,
    experience,
    skill_area,
    state,
    district,
    cluster_name,
    school_name,
    address,
    role,
    isBlocked,
    createdAt,
    images,
    profile_complete,
  } = enqState;

  useEffect(() => {
    dispatch(getaUser(getEnqId));
  }, [dispatch, getEnqId]);
  const goBack = () => {
    navigate(-1);
  };

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center">
        <h3 className="mb-4 title">View VT/VC Full Information</h3>
        <button
          className="bg-transpatent border-0 fs-6 mb-0 d-flex align-items-center gap-1"
          onClick={goBack}
        >
          <BiArrowBack className="fs-5" /> Go Back
        </button>
      </div>
      <div className="mt-5 bg-white p-4 d-flex gap-3 flex-column rounded-3">
        <div className="d-flex align-items-center gap-3">
          <div className="d-flex align-items-center gap-3">
            <h6 className="mb-0">Unique Id:</h6>
            <p className="mb-0">{unique_id}</p>
          </div>

          <div className="d-flex align-items-center gap-3">
            <h6 className="mb-0">Name:</h6>
            <p className="mb-0">{name}</p>
          </div>

          <div className="d-flex align-items-center gap-3">
            <h6 className="mb-0">Mobile:</h6>
            <p className="mb-0">
              <a href={`tel:+91${phone_no}`}>{phone_no}</a>
            </p>
          </div>
          <div className="d-flex align-items-center gap-3">
            <h6 className="mb-0">Email:</h6>
            <p className="mb-0">{email}</p>
          </div>

          <div className="d-flex align-items-center gap-3">
            <h6 className="mb-0">Qualification:</h6>
            <p className="mb-0">{qualification}</p>
          </div>

          <div className="d-flex align-items-center gap-3">
            <h6 className="mb-0">Experience:</h6>
            <p className="mb-0">{experience}</p>
          </div>

          <div className="d-flex align-items-center gap-3">
            <h6 className="mb-0">Skill Area:</h6>
            <p className="mb-0">{skill_area}</p>
          </div>

          <div className="d-flex align-items-center gap-3">
            <h6 className="mb-0">state:</h6>
            <p className="mb-0">{state}</p>
          </div>
          <div className="d-flex align-items-center gap-3">
            <h6 className="mb-0">District:</h6>
            <p className="mb-0">{district}</p>
          </div>
          <div className="d-flex align-items-center gap-3">
            <h6 className="mb-0">School Name:</h6>
            <p className="mb-0">{school_name}</p>
          </div>

          <div className="d-flex align-items-center gap-3">
            <h6 className="mb-0">Address:</h6>
            <p className="mb-0">{address}</p>
          </div>
          <div className="d-flex align-items-center gap-3">
            <h6 className="mb-0">Role:</h6>
            <p className="mb-0">{role}</p>
          </div>
          <div className="d-flex align-items-center gap-3">
            <h6 className="mb-0">isBlocked:</h6>
            <p className="mb-0">{isBlocked ? "Yes" : "No"}</p>
            <p className="mb-0">{isBlocked ? "Yes" : "No"}</p>
          </div>
          <div className="d-flex align-items-center gap-3">
            <h6 className="mb-0">Created At:</h6>
            <p className="mb-0">{createdAt}</p>
          </div>

          <div className="d-flex align-items-center gap-3">
            <h6 className="mb-0">Profile complete:</h6>
            <p className="mb-0">{profile_complete ? "Yes" : "No"}</p>
            <p className="mb-0">{profile_complete ? "Yes" : "No"}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewCustomer;
